/**
 * Payment-mode helpers.
 *
 * When Stripe is configured with a test key, a real card at checkout fails with
 * "your request was in test mode, but used a non test card". That is a dead end
 * for a visitor on the published site, so paid CTAs must not open checkout at
 * all in that state. On preview/localhost we still allow it — that is where
 * test cards are meant to be used.
 */

/** True on localhost and Lovable preview hosts (safe to run test checkouts). */
export function isPreviewHost(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return (
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h.endsWith('.lovableproject.com') ||
    h.startsWith('id-preview--') ||
    h.includes('--')
  );
}

export const TEST_MODE_PREVIEW_MESSAGE =
  'Stripe is in test mode — use a Stripe test card (4242 4242 4242 4242). Real cards will decline.';

export const TEST_MODE_LIVE_MESSAGE =
  'Payments are temporarily unavailable while billing is being finalised. Nothing will be charged.';

export function paymentDisabledMessage(): string {
  return isPreviewHost() ? TEST_MODE_PREVIEW_MESSAGE : TEST_MODE_LIVE_MESSAGE;
}
